import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip,
} from "recharts";
import { SKILLS } from "@/lib/framework";

// series: [{ key, name, color, scores: {skillId: value} }]
export function SkillRadar({ series, height = 340, testId }) {
  const data = SKILLS.map((s) => {
    const row = { skill: s.short, fullMark: 4 };
    series.forEach((ser) => { row[ser.key] = ser.scores[s.id] ?? 0; });
    return row;
  });
  return (
    <div style={{ width: "100%", height }} data-testid={testId}>
      <ResponsiveContainer>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#e2e8f0" />
          <PolarAngleAxis dataKey="skill" tick={{ fontSize: 11, fill: "#475569" }} />
          <PolarRadiusAxis domain={[0, 4]} tickCount={5} tick={{ fontSize: 9, fill: "#94a3b8" }} axisLine={false} />
          {series.map((ser) => (
            <Radar
              key={ser.key}
              name={ser.name}
              dataKey={ser.key}
              stroke={ser.color}
              fill={ser.color}
              fillOpacity={ser.fillOpacity ?? 0.35}
              strokeWidth={2}
              isAnimationActive
            />
          ))}
          {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
          <Tooltip formatter={(v) => Number(v).toFixed(2)} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
